import { render, staticRenderFns } from "./StockOperationCard.vue?vue&type=template&id=72888b58"
import script from "./StockOperationCard.vue?vue&type=script&lang=js"
export * from "./StockOperationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileImg: require('/skade-pwa/components/ui/atom/ProfileImg.vue').default,Truncate: require('/skade-pwa/components/ui/atom/Truncate.vue').default,ChangePercent: require('/skade-pwa/components/ui/atom/ChangePercent.vue').default,Spinner: require('/skade-pwa/components/ui/atom/Spinner.vue').default})
